import React from 'react'
import './ChooseUs.css'
import ServiceIcon9 from '../../../Img/ser-icon9.png'
import ServiceIcon10 from '../../../Img/ser-icon10.png'
import ServiceIcon12 from '../../../Img/ser-icon12.png'
import ServiceIcon21 from '../../../Img/ser-icon21.png'
import ServiceIcon22 from '../../../Img/ser-icon22.png'
import Counter1 from '../../../Img/counter-1.png'
import Counter2 from '../../../Img/counter-2.png'
import Counter3 from '../../../Img/counter-3.png'

import { FaRocket, FaLock, FaRegWindowMaximize, FaHeadset, FaRegArrowAltCircleUp, FaMoneyBillAlt, FaUsers, FaBolt } from 'react-icons/fa';

const ChooseUs = () => {
  return (
    <div class="section harsafe-choose-us-section section-padding">
    <div class="container">
        {/* <!-- Choose Us Wrap Start --> */}
        <div class="choose-us-wrap">
            <div class="section-title text-center">
                <h3 class="sub-title">REASON TO CHOOSE US</h3>
                <h2 class="title">Top Reasons Why Our Services Stand Out</h2>
            </div>
            <div class="choose-us-content-wrap">
                <div class="row">
                    <div class="col-xl-3 col-lg-4 col-md-6 mb-3">
                        {/* <!-- Choose Us Item Start --> */}
                        <div class="choose-us-item-02">
                            <div class="choose-us-img">
                            <FaRocket />
                            {/* <img src={ServiceIcon9} alt=""/> */}
                            </div>
                            <div class="choose-us-content">
                                <h3 class="title"><a href="#">Innovative Solutions</a></h3>
                                <p>We offer unique, cutting-edge products that stand out in the market.</p>
                            </div>
                        </div>
                        {/* <!-- Choose Us Item End --> */}
                    </div>
                    <div class="col-xl-3 col-lg-4 col-md-6 mb-3">
                        {/* <!-- Choose Us Item Start --> */}
                        <div class="choose-us-item-02">
                            <div class="choose-us-img">
                            <FaLock />
                            {/* <img src={Counter3} alt=""/> */}
                            </div>
                            <div class="choose-us-content">
                                <h3 class="title"><a href="#">High-Level Security</a></h3>
                                <p>Accelerate innovation with world-class tech teams We’ll match you to an entire.</p>
                            </div>
                        </div>
                        {/* <!-- Choose Us Item End --> */}
                    </div>
                    <div class="col-xl-3 col-lg-4 col-md-6 mb-3">
                        {/* <!-- Choose Us Item Start --> */}
                        <div class="choose-us-item-02">
                            <div class="choose-us-img">
                            <FaRegWindowMaximize />
                                {/* <img src={ServiceIcon10} alt=""/> */}
                            </div>
                            <div class="choose-us-content">
                                <h3 class="title"><a href="#">Seamless User Experience</a></h3>
                                <p>Our interfaces are intuitive, ensuring smooth and easy navigation for users.</p>
                            </div>
                        </div>
                        {/* <!-- Choose Us Item End --> */}
                    </div>
                    <div class="col-xl-3 col-lg-4 col-md-6 mb-3">
                        {/* <!-- Choose Us Item Start --> */}
                        <div class="choose-us-item-02">
                            <div class="choose-us-img">
                            <FaHeadset />
                            {/* <img src={ServiceIcon12} alt=""/> */}
                            </div>
                            <div class="choose-us-content">
                                <h3 class="title"><a href="#">24/7 Customer Support</a></h3>
                                <p>We provide round-the-clock assistance to resolve any issues or queries.</p>
                            </div>
                        </div>
                        {/* <!-- Choose Us Item End --> */}
                    </div>
                    <div class="col-xl-3 col-lg-4 col-md-6 mb-3">
                        {/* <!-- Choose Us Item Start --> */}
                        <div class="choose-us-item-02">
                            <div class="choose-us-img">
                            <FaRegArrowAltCircleUp />
                            {/* <img src={Counter2} alt=""/> */}
                            </div>
                            <div class="choose-us-content">
                                <h3 class="title"><a href="#">Scalable Solutions</a></h3>
                                <p>Our products are adaptable, growing with your business needs and demands.</p>
                            </div>
                        </div>
                        {/* <!-- Choose Us Item End --> */}
                    </div>
                    <div class="col-xl-3 col-lg-4 col-md-6 mb-3">
                        {/* <!-- Choose Us Item Start --> */}
                        <div class="choose-us-item-02">
                            <div class="choose-us-img">
                            <FaMoneyBillAlt />
                            {/* <img src={Counter3} alt=""/> */}
                            </div>
                            <div class="choose-us-content">
                                <h3 class="title"><a href="#">Cost-Effective Services</a></h3>
                                <p>We deliver premium services at competitive prices, offering great value for money.</p>
                            </div>
                        </div>
                        {/* <!-- Choose Us Item End --> */}
                    </div>
                    <div class="col-xl-3 col-lg-4 col-md-6 mb-3">
                        {/* <!-- Choose Us Item Start --> */}
                        <div class="choose-us-item-02">
                            <div class="choose-us-img">
                            <FaUsers />
                            {/* <img src={ServiceIcon21} alt=""/> */}
                            </div>
                            <div class="choose-us-content">
                                <h3 class="title"><a href="#">Expert Team</a></h3>
                                <p>Our team consists of skilled professionals committed to excellence in every project.</p>
                            </div>
                        </div>
                        {/* <!-- Choose Us Item End --> */}
                    </div>
                    <div class="col-xl-3 col-lg-4 col-md-6 mb-3">
                        {/* <!-- Choose Us Item Start --> */}
                        <div class="choose-us-item-02">
                            <div class="choose-us-img">
                            <FaBolt />
                            {/* <img src={ServiceIcon22} alt=""/> */}
                            </div>
                            <div class="choose-us-content">
                                <h3 class="title"><a href="#">Fast and Reliable</a></h3>
                                <p>We ensure fast, reliable performance across all our applications and services.</p>
                            </div>
                        </div>
                        {/* <!-- Choose Us Item End --> */}
                </div>

                </div>
            </div>
        </div>
        {/* <!-- Choose Us Wrap End --> */}
    </div>
</div>

  )
}


export default ChooseUs